import type { TranslationTable } from "@repo/shared/types";

const EN_GB = {
  adviceToCheck: "Advice to check",
  adviceToCheckDescription: "Completed in the period · not reviewed or flagged",
  colFlow: "Flow",
  colCompleted: "Completed",
  colCheck: "Check",
  colClient: "Client",
  colUser: "User",
  openFlowsReview: "Open flows review",
  noAdvice: "No completed advice is waiting for a check.",
  notReviewed: "Not reviewed",
  flagged: "Flagged",
};

// All 17 locales (QL-17 plan keeps them); the type makes each one match EN_GB.
export const T: TranslationTable<typeof EN_GB> = {
  en_GB: EN_GB,
  fr_FR: {
    adviceToCheck: "Conseils à contrôler",
    adviceToCheckDescription: "Terminés sur la période · non revus ou signalés",
    colFlow: "Parcours",
    colCompleted: "Terminé",
    colCheck: "Contrôle",
    colClient: "Client",
    colUser: "Utilisateur",
    openFlowsReview: "Ouvrir la revue des parcours",
    noAdvice: "Aucun conseil terminé n'est en attente de contrôle.",
    notReviewed: "Non revu",
    flagged: "Signalé",
  },
  es_ES: {
    adviceToCheck: "Asesoramientos por revisar",
    adviceToCheckDescription: "Completados en el periodo · sin revisar o marcados",
    colFlow: "Flujo",
    colCompleted: "Completado",
    colCheck: "Control",
    colClient: "Cliente",
    colUser: "Usuario",
    openFlowsReview: "Abrir revisión de flujos",
    noAdvice: "No hay asesoramientos completados pendientes de control.",
    notReviewed: "Sin revisar",
    flagged: "Marcado",
  },
  pt_BR: {
    adviceToCheck: "Recomendações a verificar",
    adviceToCheckDescription: "Concluídas no período · não revisadas ou sinalizadas",
    colFlow: "Fluxo",
    colCompleted: "Concluído",
    colCheck: "Verificação",
    colClient: "Cliente",
    colUser: "Usuário",
    openFlowsReview: "Abrir revisão de fluxos",
    noAdvice: "Nenhuma recomendação concluída aguarda verificação.",
    notReviewed: "Não revisado",
    flagged: "Sinalizado",
  },
  de_DE: {
    adviceToCheck: "Zu prüfende Beratungen",
    adviceToCheckDescription: "Im Zeitraum abgeschlossen · nicht geprüft oder markiert",
    colFlow: "Flow",
    colCompleted: "Abgeschlossen",
    colCheck: "Prüfung",
    colClient: "Kunde",
    colUser: "Benutzer",
    openFlowsReview: "Flow-Prüfung öffnen",
    noAdvice: "Keine abgeschlossenen Beratungen warten auf Prüfung.",
    notReviewed: "Nicht geprüft",
    flagged: "Markiert",
  },
  it_IT: {
    adviceToCheck: "Consulenze da verificare",
    adviceToCheckDescription: "Completate nel periodo · non revisionate o segnalate",
    colFlow: "Flusso",
    colCompleted: "Completato",
    colCheck: "Controllo",
    colClient: "Cliente",
    colUser: "Utente",
    openFlowsReview: "Apri revisione flussi",
    noAdvice: "Nessuna consulenza completata è in attesa di controllo.",
    notReviewed: "Non revisionato",
    flagged: "Segnalato",
  },
  ar: {
    adviceToCheck: "استشارات للفحص",
    adviceToCheckDescription: "مكتملة خلال الفترة · لم تتم مراجعتها أو مُعلَّمة",
    colFlow: "المسار",
    colCompleted: "تاريخ الإكمال",
    colCheck: "الفحص",
    colClient: "العميل",
    colUser: "المستخدم",
    openFlowsReview: "فتح مراجعة المسارات",
    noAdvice: "لا توجد استشارات مكتملة بانتظار الفحص.",
    notReviewed: "لم تتم مراجعتها",
    flagged: "مُعلَّمة",
  },
  ja_JP: {
    adviceToCheck: "チェック対象のアドバイス",
    adviceToCheckDescription: "期間内に完了 · 未レビューまたは要確認",
    colFlow: "フロー",
    colCompleted: "完了日",
    colCheck: "チェック",
    colClient: "顧客",
    colUser: "ユーザー",
    openFlowsReview: "フローレビューを開く",
    noAdvice: "チェック待ちの完了済みアドバイスはありません。",
    notReviewed: "未レビュー",
    flagged: "要確認",
  },
  hi_IN: {
    adviceToCheck: "जाँच हेतु सलाह",
    adviceToCheckDescription: "अवधि में पूर्ण · समीक्षा नहीं हुई या फ़्लैग की गई",
    colFlow: "फ़्लो",
    colCompleted: "पूर्ण",
    colCheck: "जाँच",
    colClient: "क्लाइंट",
    colUser: "उपयोगकर्ता",
    openFlowsReview: "फ़्लो समीक्षा खोलें",
    noAdvice: "कोई पूर्ण सलाह जाँच की प्रतीक्षा में नहीं है।",
    notReviewed: "समीक्षा नहीं हुई",
    flagged: "फ़्लैग किया गया",
  },
  zh_CN: {
    adviceToCheck: "待检查的建议",
    adviceToCheckDescription: "期间内已完成 · 未审核或已标记",
    colFlow: "流程",
    colCompleted: "完成时间",
    colCheck: "检查",
    colClient: "客户",
    colUser: "用户",
    openFlowsReview: "打开流程审核",
    noAdvice: "没有等待检查的已完成建议。",
    notReviewed: "未审核",
    flagged: "已标记",
  },
  zh_TW: {
    adviceToCheck: "待檢查的建議",
    adviceToCheckDescription: "期間內已完成 · 未審核或已標記",
    colFlow: "流程",
    colCompleted: "完成時間",
    colCheck: "檢查",
    colClient: "客戶",
    colUser: "使用者",
    openFlowsReview: "開啟流程審核",
    noAdvice: "沒有等待檢查的已完成建議。",
    notReviewed: "未審核",
    flagged: "已標記",
  },
  nl_NL: {
    adviceToCheck: "Te controleren advies",
    adviceToCheckDescription: "Voltooid in de periode · niet beoordeeld of gemarkeerd",
    colFlow: "Flow",
    colCompleted: "Voltooid",
    colCheck: "Controle",
    colClient: "Klant",
    colUser: "Gebruiker",
    openFlowsReview: "Flowbeoordeling openen",
    noAdvice: "Er wacht geen voltooid advies op controle.",
    notReviewed: "Niet beoordeeld",
    flagged: "Gemarkeerd",
  },
  nb_NO: {
    adviceToCheck: "Råd å kontrollere",
    adviceToCheckDescription: "Fullført i perioden · ikke gjennomgått eller flagget",
    colFlow: "Flyt",
    colCompleted: "Fullført",
    colCheck: "Kontroll",
    colClient: "Kunde",
    colUser: "Bruker",
    openFlowsReview: "Åpne flytgjennomgang",
    noAdvice: "Ingen fullførte råd venter på kontroll.",
    notReviewed: "Ikke gjennomgått",
    flagged: "Flagget",
  },
  sv_SE: {
    adviceToCheck: "Rådgivning att kontrollera",
    adviceToCheckDescription: "Slutförd under perioden · ej granskad eller flaggad",
    colFlow: "Flöde",
    colCompleted: "Slutförd",
    colCheck: "Kontroll",
    colClient: "Kund",
    colUser: "Användare",
    openFlowsReview: "Öppna flödesgranskning",
    noAdvice: "Ingen slutförd rådgivning väntar på kontroll.",
    notReviewed: "Ej granskad",
    flagged: "Flaggad",
  },
  fi_FI: {
    adviceToCheck: "Tarkastettava neuvonta",
    adviceToCheckDescription: "Valmistunut jakson aikana · ei tarkastettu tai merkitty",
    colFlow: "Prosessi",
    colCompleted: "Valmistunut",
    colCheck: "Tarkastus",
    colClient: "Asiakas",
    colUser: "Käyttäjä",
    openFlowsReview: "Avaa prosessien tarkastus",
    noAdvice: "Yksikään valmis neuvonta ei odota tarkastusta.",
    notReviewed: "Ei tarkastettu",
    flagged: "Merkitty",
  },
  da_DK: {
    adviceToCheck: "Rådgivning til kontrol",
    adviceToCheckDescription: "Gennemført i perioden · ikke gennemgået eller markeret",
    colFlow: "Forløb",
    colCompleted: "Gennemført",
    colCheck: "Kontrol",
    colClient: "Kunde",
    colUser: "Bruger",
    openFlowsReview: "Åbn forløbsgennemgang",
    noAdvice: "Ingen gennemført rådgivning afventer kontrol.",
    notReviewed: "Ikke gennemgået",
    flagged: "Markeret",
  },
  is_IS: {
    adviceToCheck: "Ráðgjöf til athugunar",
    adviceToCheckDescription: "Lokið á tímabilinu · ekki yfirfarið eða flaggað",
    colFlow: "Ferli",
    colCompleted: "Lokið",
    colCheck: "Athugun",
    colClient: "Viðskiptavinur",
    colUser: "Notandi",
    openFlowsReview: "Opna yfirferð ferla",
    noAdvice: "Engin lokin ráðgjöf bíður athugunar.",
    notReviewed: "Ekki yfirfarið",
    flagged: "Flaggað",
  },
};
